import React from 'react';
import { Link } from 'react-router-dom';
import DestinationLogo from './DestinationLogo';
import './Header.css';

function Header({ isStaffApp }) {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="site-header__brand" aria-label="Destination Success Home">
          <DestinationLogo height={40} />
        </Link>
        <span className="site-header__eyebrow">
          {isStaffApp ? 'VMHS · CTE Senior Awards · Staff RSVP' : 'VMHS · Class of 2026'}
        </span>
      </div>
      <div className="site-header__path" aria-hidden="true">
        <svg viewBox="0 0 1200 12" preserveAspectRatio="none">
          <path
            d="M 0 6 Q 300 -2 600 6 T 1200 6"
            fill="none"
            stroke="rgba(244, 162, 97, 0.55)"
            strokeWidth="1"
            strokeDasharray="3 5"
          />
        </svg>
      </div>
    </header>
  );
}

export default Header;
